/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
 
  document.addEventListener("DOMContentLoaded", function () {
    const checkoutButton = document.querySelector('[name="checkout"]');
    const giftNoteTextarea = document.querySelector('textarea[name="attributes[Gift note]"]');

   // console.log("Checkout button:", checkoutButton); // Debug
   // console.log("Gift note textarea:", giftNoteTextarea); // Debug

    const cartWidgetTitle = document.querySelector('.cart__widget__title');

    if (giftNoteTextarea && cartWidgetTitle) {
      if (giftNoteTextarea.value.trim() !== '') {
        cartWidgetTitle.click();
      }
    }
    
    if (checkoutButton && giftNoteTextarea) {
      checkoutButton.addEventListener("click", function (e) {
        const note = giftNoteTextarea.value.trim();
        console.log("Gift note value:", note); // Debug

        if (note === "") {
          e.preventDefault();
          alert("Please enter a gift note before checking out.");
          document.querySelector('.cart__widget__title').click();
          giftNoteTextarea.focus();
        } else {
          giftNoteTextarea.classList.add("expanded");
        }
      });
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
  console.log('Script loaded'); // Confirm script runs 
})();
